export const TYPE_SHELF = "SHELF";
export const TYPE_DIVIDER = "DIVIDER";

export const TYPES = [
    {
        code: TYPE_SHELF,
        label: "Shelf"
    },
    {
        code: TYPE_DIVIDER,
        label: "Divider"
    }
];



// WEBPACK FOOTER //
// ./src/store/catalog/typeStructure.js